// Owner 2026-10-12: a COA is entered as the time the person is AWAY ("8:00 to 10:00 AM"),
// the way people think about it. The record (and payroll, which credits
// ModifiedEnd - ModifiedStart as the hours worked) keeps the legacy meaning: the hours
// the person WILL work that day. These helpers convert both ways against the standard
// 8:00 AM - 4:30 PM day (owner rule: working day 8:00 - 4:30).
export const DAY_START = "08:00";
export const DAY_END = "16:30";

export const toMinutes = (hhmm) => {
    if (!hhmm || typeof hhmm !== "string") return null;
    const [h, m] = hhmm.split(":").map((x) => parseInt(x, 10));
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
};
const pad = (n) => String(n).padStart(2, "0");
export const fromMinutes = (min) => `${pad(Math.floor(min / 60))}:${pad(min % 60)}`;
export const pretty = (hhmm) => {
    const min = toMinutes(hhmm);
    if (min == null) return "";
    const h = Math.floor(min / 60), m = min % 60;
    const h12 = ((h + 11) % 12) + 1;
    return `${h12}:${pad(m)} ${h < 12 ? "AM" : "PM"}`;
};

/** The hours worked that day for an away window. Returns null when the window is not usable. */
export const awayToWorked = (awayFrom, awayUntil) => {
    const s = toMinutes(awayFrom), e = toMinutes(awayUntil);
    const ds = toMinutes(DAY_START), de = toMinutes(DAY_END);
    if (s == null || e == null || e <= s) return null;
    if (s <= ds) {
        // away at the start of the day: comes in when the absence ends
        return { start: fromMinutes(Math.max(e, ds)), end: DAY_END };
    }
    if (e >= de) {
        // away until the end of the day: leaves when the absence starts
        return { start: DAY_START, end: fromMinutes(Math.min(s, de)) };
    }
    // away in the middle of the day: the same hours are missing, so the record ends
    // that much earlier (payroll credits the difference, which is what matters)
    return { start: DAY_START, end: fromMinutes(de - (e - s)) };
};

/** The away window a stored record most likely meant; null when it cannot be told. */
export const workedToAway = (start, end) => {
    const s = toMinutes(start), e = toMinutes(end);
    const ds = toMinutes(DAY_START), de = toMinutes(DAY_END);
    if (s == null || e == null) return null;
    if (s > ds && e >= de) return { awayFrom: DAY_START, awayUntil: fromMinutes(s) };
    if (s <= ds && e < de) return { awayFrom: fromMinutes(e), awayUntil: DAY_END };
    return null;
};
